import { useContext, useState } from "react";
import { SelectFormField } from "./SelectFormField";
import checkoutContext from "../../../../checkout-context";
import { FormField } from "./FormField";

type CountrySelectProps = {
  defaultValues?: {
    defaultCountry?: boolean;
    country?: string;
  };
};

export function CountrySelect({ defaultValues }: CountrySelectProps) {
  const [defaultCountry, setDefaultCountry] = useState(
    defaultValues?.defaultCountry ?? true
  );
  const { textsMapping, data: checkoutData } = useContext(checkoutContext);
  const { countries } = checkoutData;

  return (
    <>
      <FormField
        label={textsMapping.countryRadioButtonNetherlands}
        type="radio"
        id="defaultCountry-true"
        checked={defaultCountry}
        onChange={() => setDefaultCountry(true)}
      />
      <FormField
        label={textsMapping.countryRadioButtonOther}
        type="radio"
        id="defaultCountry-false"
        checked={!defaultCountry}
        onChange={() => setDefaultCountry(false)}
      />
      {!defaultCountry && (
        <SelectFormField
          defaultValue={defaultValues?.country}
          label={textsMapping.homeAddressCountryLabel}
          placeholder={textsMapping.homeAddressCountryPlaceholder}
          options={countries}
          name="address.country"
          required
        />
      )}
      <FormField
        name="address.defaultCountry"
        value={defaultCountry.toString()}
        type="hidden"
        required
      />
    </>
  );
}
